import { render, staticRenderFns } from "./Collapser.vue?vue&type=template&id=e75989ae&scoped=true&"
import script from "./Collapser.vue?vue&type=script&lang=js&"
export * from "./Collapser.vue?vue&type=script&lang=js&"
import style0 from "./Collapser.vue?vue&type=style&index=0&id=e75989ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75989ae",
  null
  
)

export default component.exports